<div class="checkbox-container" [ngClass]="{ 'point-mark': pointMark }">
  <div class="checkbox">
    <label class="checkbox-item">
      <mat-checkbox [checked]="initialState" [value]="true" (change)="handleChange($event)">
        {{text}}
      </mat-checkbox>
    </label>
  </div>
</div>
